import { render, staticRenderFns } from "./carteirinha.vue?vue&type=template&id=6d058548"
import script from "./carteirinha.vue?vue&type=script&lang=js"
export * from "./carteirinha.vue?vue&type=script&lang=js"
import style0 from "./carteirinha.vue?vue&type=style&index=0&id=6d058548&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports